import React, { useState } from "react";

// Retries a failed image a couple of times, then falls back to the original file.
export const RetryImg = ({ src, fallback, ...props }) => {
  const [tries, setTries] = useState(0);
  const useFallback = fallback && tries >= 2;
  const base = useFallback ? fallback : src;
  const url = tries === 0 || useFallback ? base : `${base}${base.includes("?") ? "&" : "?"}r=${tries}`;

  const onError = () => {
    if (tries < 3) setTimeout(() => setTries((t) => t + 1), 800 * (tries + 1));
  };

  return <img src={url} onError={onError} {...props} />;
};
